import { Clock, Truck, CheckCircle, Shield, Snowflake, Star } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useEffect, useState } from "react";

const UrgencyBanner = () => {
  const { t } = useLanguage();
  const now = new Date();
  const cutoffHour = 12;
  const hoursLeft = cutoffHour - now.getHours();
  const minutesLeft = 60 - now.getMinutes();
  const isBeforeCutoff = now.getHours() < cutoffHour;

  const usps = [
    ...(isBeforeCutoff
      ? [
          {
            icon: Clock,
            text: `${t("urgency.orderBefore")} 12:00 = ${t("urgency.deliveryTomorrow")}`,
          },
        ]
      : []),
    { icon: CheckCircle, text: t("urgency.deliveryRate") },
    { icon: Shield, text: t("urgency.certified") },
    { icon: Truck, text: t("urgency.nextDay") },
    { icon: Snowflake, text: t("urgency.freshProduced") },
    { icon: Star, text: t("urgency.available247") },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % usps.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [usps.length]);

  const safeIndex = current % usps.length;
  const Icon = usps[safeIndex].icon;

  return (
    <div className="bg-card border-b border-border py-2 px-4">
      <div className="container mx-auto flex items-center justify-center gap-2 text-xs sm:text-sm font-medium text-foreground h-5 overflow-hidden relative" role="status" aria-live="polite" aria-atomic="true">
        <div
          key={safeIndex}
          className="flex items-center gap-2 animate-in fade-in slide-in-from-bottom-2 duration-500"
        >
          <Icon className="w-3.5 h-3.5 flex-shrink-0 text-primary" aria-hidden="true" />
          <span className="whitespace-nowrap">{usps[safeIndex].text}</span>
        </div>
      </div>
    </div>
  );
};

export default UrgencyBanner;
